import { LoaderIcon as SmallLoaderIcon } from '@rhim/icons/16/LoaderIcon';
import { LoaderInvertedIcon as SmallLoaderInvertedIcon } from '@rhim/icons/16/LoaderInvertedIcon';
import { LoaderIcon as MiddleLoaderIcon } from '@rhim/icons/24/LoaderIcon';
import { LoaderInvertedIcon } from '@rhim/icons/24/LoaderInvertedIcon';
import { LoaderIcon as LargeLoaderIcon } from '@rhim/icons/64/LoaderIcon';
import { spinner } from '@rhim/test-ids';
import React from 'react';
import styled from 'styled-components';

interface Props {
  size: '16' | '24' | '64';
  inverted?: boolean;
  rotationDuration?: number;
}

const Spinner: React.FC<Readonly<React.PropsWithChildren<Props>>> = ({ size, inverted = false, rotationDuration = 1, ...rest }) => {
  let loaderIcon;

  switch (size) {
    case '16':
      loaderIcon = inverted ? <SmallLoaderInvertedIcon /> : <SmallLoaderIcon />;
      break;
    case '24':
      loaderIcon = inverted ? <LoaderInvertedIcon /> : <MiddleLoaderIcon />;
      break;
    case '64':
      loaderIcon = <LargeLoaderIcon />;
      break;
  }

  return (
    <SpinnerWrapper $rotationDuration={rotationDuration} {...rest} data-test-id={spinner}>
      <IconWrapper>{loaderIcon}</IconWrapper>
    </SpinnerWrapper>
  );
};

const SpinnerWrapper = styled.div<{ $rotationDuration: number }>`
  display: inline-block;
  vertical-align: middle;
  pointer-events: none;

  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }

  svg {
    animation: ${(props) => `rotate ${props.$rotationDuration}s linear infinite`};
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

Spinner.whyDidYouRender = true;

const SpinnerMemo = React.memo(Spinner);
SpinnerMemo.displayName = 'Spinner';

export default SpinnerMemo;
